import { type ClassValue, clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

/**
 * Substitutes `{token}` placeholders in a translated label template with values.
 * Used by components that accept pre-translated label props but still need to
 * interpolate dynamic values (counts, captured samples) computed at render time.
 */
export function formatTemplate(template: string, tokens: Record<string, string | number>): string {
  return Object.entries(tokens).reduce(
    (text, [key, value]) => text.replaceAll(`{${key}}`, String(value)),
    template,
  );
}
